// extracted by mini-css-extract-plugin
export var root = "PlasmicTag-module--root--pTGDs";
export var rootstroke = "PlasmicTag-module--rootstroke--+ZG-S";
export var rootflippabble = "PlasmicTag-module--rootflippabble--2dGdV";
export var slotTargetLabel = "PlasmicTag-module--slotTargetLabel--6vRHo";
export var text___7ZTu = "PlasmicTag-module--text___7ZTu---EpSK";